if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // 1. GATHER FORM VALUES
        const formData = new FormData(this.form);
        const variantId = parseInt(formData.get('id'), 10);
        const qty = parseInt(formData.get('quantity') || 1, 10);

        // 2. GATHER CUSTOMIZATION (NAME & NUMBER)
        const nameEl = document.getElementById('jz-input-name') || document.querySelector('input[name="properties[Name]"]');
        const numEl = document.getElementById('jz-input-number') || document.querySelector('input[name="properties[Number]"]');
        const customName = (nameEl ? nameEl.value.trim() : '') || window.__jz_custom_name || '';
        const customNumber = (numEl ? numEl.value.trim() : '') || window.__jz_custom_number || '';

        const properties = {};
        for (const [k, v] of formData.entries()) {
          if (k.startsWith('properties[') && v) {
            properties[k.replace('properties[', '').replace(']', '')] = v;
          }
        }

        if (customName) properties['Name'] = customName;
        if (customNumber) properties['Number'] = customNumber;

        // 3. GATHER SELECTED PATCHES (CASCADING SAFE LOOKUP)
        let selectedPatches = [];
        if (typeof window.getAccordionPatches === 'function') {
          selectedPatches = window.getAccordionPatches();
        }
        if ((!selectedPatches || selectedPatches.length === 0) && typeof window.getSelectedPatches === 'function') {
          selectedPatches = window.getSelectedPatches();
        }
        if (!selectedPatches || selectedPatches.length === 0) {
          selectedPatches = window.__jz_selected_patches || [];
        }

        const pairingId = 'p_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);

        if (selectedPatches && selectedPatches.length > 0) {
          properties['_Vínculo'] = pairingId;
          properties['Patches'] = selectedPatches.map(p => (p.name || p.title || '').replace(/^(Patch(es)?\s*:?\s*)/i, '').trim()).join(', ');
        }

        const items = [{
          id: variantId,
          quantity: qty,
          properties: properties
        }];

        if (selectedPatches && selectedPatches.length > 0) {
          selectedPatches.forEach(p => {
            const vId = parseInt(p.variantId || p.id, 10);
            if (vId) {
              items.push({
                id: vId,
                quantity: qty,
                properties: {
                  '_Vínculo': pairingId,
                  '_Attached_to': 'Jersey',
                  'Position': p.position === 'Manga' ? 'Sleeve' : (p.position === 'Peito' ? 'Chest' : (p.position || 'Sleeve'))
                }
              });
            }
          });
        }

        console.log('[ProductForm] Adding items to cart:', items);

        const sections = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        const bodyPayload = {
          items: items,
          sections: sections.join(','),
          sections_url: window.location.pathname
        };

        const postConfig = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify(bodyPayload)
        };

        fetch(`${routes.cart_add_url}.js`, postConfig)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status && response.status >= 400) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description || response.message);
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            let renderState = response;
            if (!response.sections && this.cart) {
              try {
                const secRes = await fetch(`/cart?sections=${sections.join(',')}`);
                if (secRes.ok) {
                  renderState = await secRes.json();
                }
              } catch (e) {}
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(renderState);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else if (this.cart) {
              this.submitButton.classList.add('is-sweeping');
              setTimeout(() => {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(renderState);
                });
                setTimeout(() => {
                  this.submitButton.classList.remove('is-sweeping');
                }, 400);
              }, 400);
            }
          })
          .catch((e) => {
            console.error('Error adding to cart:', e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
